/**
 * 멱등키 생성. 최대 64자 제한을 지키는 UUID v4(36자).
 *
 * 🚫 `Math.random` 폴백을 두지 않는다 — 예측 가능한 키는 남의 요청에 접근하는 통로가 된다.
 * 안전한 난수를 못 쓰는 환경이면 요청을 시작하지 않는 편이 옳다(fail-closed).
 *
 * (구 `lib/venue/passPurchaseSession.ts`에서 이관 — 이용권 결제 전용이 아니라 `ReservationCancelModal`도
 * 재시도 멱등성에 이 함수를 쓴다. 이용권 결제 세션 자체(`resolveIdempotencyKey`·`sessionStorage` 수명
 * 관리)는 이용권과 함께 삭제됐다.)
 */
export function newIdempotencyKey(): string {
  const webCrypto = globalThis.crypto

  if (typeof webCrypto?.randomUUID === 'function') return webCrypto.randomUUID()

  if (typeof webCrypto?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    webCrypto.getRandomValues(bytes)
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
  }

  throw new Error('안전한 난수 생성기를 사용할 수 없어 요청을 시작할 수 없습니다.')
}
